module.exports = __webpack_public_path__ + "img/icon-white-55.68a0a37f.svg";